import PastVisitsCollection from 'models/Provider/PastVisitsCollection'
import VisitCard from 'components/Dashboard/cards/Visit'
import DateBlock from '../Visit/TabPanel/tabs/Visits/common/DateBlock'
import SectionList from '../common/SectionList'
import SectionRow from '../common/SectionRow'
import User from 'singletons/User'
import { ReactNode } from 'react'
import Placeholder from 'components/Dashboard/common/Placeholder'

type PastVisitsListOldProps = { list: PastVisitsCollection['list']; header?: ReactNode }

const PastVisitsListOld = ({ list, header }: PastVisitsListOldProps) => {
  return (
    <div className="max-w-[1500px] mr-6 sm:mr-10 ml-4 mt-10">
      {!!header && <div className="mb-10">{header}</div>}
      {list?.length ? (
        <SectionList className="min-w-[35vw] max-w-full w-full">
          {list.map((pastVisit) => {
            return (
              <SectionRow
                leftContent={<DateBlock date={pastVisit.scheduledAt} />}
                rightContent={
                  <VisitCard memberMode visit={pastVisit} editable={User.providerId === pastVisit.providerId} />
                }
                key={pastVisit.pendingVisitId}
              />
            )
          })}
        </SectionList>
      ) : (
        <Placeholder text="No visits found." icon="visits" />
      )}
    </div>
  )
}

export default PastVisitsListOld
